import { useMediaQuery } from "@uidotdev/usehooks"
import PageContainer from "components/PageContainer"
import TopHeadingBar from "components/TopHeadingBar"
import CpatBanner from "features/Cpat/Banners/CpatHomeScreenBanner"
import NeedHelpBanner from "features/Home/NeedHelpBanner"
import ResumeLearning from "features/Home/ResumeLearning"
import ScheduleBanner from "features/Home/ScheduleBanner"
import UpcomingMasterclass from "features/Masterclasses/UpcomingMasterclass"
import { useAutomaticNotificationAction } from "features/Notifications/hooks/useAutomaticNotificationAction"
import { breakpoints } from "utils/createBreakpoints"

const SuraasaSureHome = () => {
  const isSmDown = useMediaQuery(breakpoints.down("sm"))

  // Automatically detects and handles notification actions from the URL (if present).
  useAutomaticNotificationAction()

  return (
    <div className="relative h-full min-h-screen bg-white">
      <TopHeadingBar heading="Home" renderBorder />
      {isSmDown ? (
        <PageContainer className="mt-2 !pb-10">
          <CpatBanner />
          <UpcomingMasterclass />
          <ScheduleBanner />
          <ResumeLearning className="mb-4.5" />
          <NeedHelpBanner />
        </PageContainer>
      ) : (
        <PageContainer className="mt-2 !pb-10 max-sm:px-0">
          <div className="grid grid-cols-12 sm:gap-2 md:gap-3">
            <div className="col-span-12 flex flex-col sm:col-span-7 md:col-span-8">
              <CpatBanner />
              <UpcomingMasterclass />
              <ResumeLearning className="mb-4.5" />
              <ScheduleBanner />
            </div>

            <div className="col-span-12 flex flex-col sm:col-span-5 md:col-span-4">
              <NeedHelpBanner />
            </div>
          </div>
        </PageContainer>
      )}
    </div>
  )
}

export default SuraasaSureHome
